export enum CharacterShowType {
  Normal = 'normal',
  NameOnly = 'name_only',
  SpaceOnly = 'space_only',
  None = 'none',
}
